"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePPG = exports.parseGyro = exports.parseAccel = exports.parseTelemetry = exports.parseEEG = void 0;
const nexus_utils_1 = require("./nexus-utils");
const c = __importStar(require("./constants"));
const ble_utils_1 = require("./ble-utils");
const time_1 = require("./time");
const getTimestampStreams = time_1.makeTimestamps(false);
function parseEEG(channel, value, gain) {
    const buffer = new Uint8Array(value.buffer);
    const samples = nexus_utils_1.decodeEEGSamples(buffer.slice(0, buffer.length - 4), gain)[channel];
    const eventIndex = ble_utils_1.decodeUint24BitData(buffer.slice(buffer.length - 4, buffer.length - 1))[0];
    return {
        channel,
        index: eventIndex,
        samples,
        timestamp: getTimestampStreams(eventIndex, c.INSAI_EEG_SAMPLING_RATE, 1, 1),
    };
}
exports.parseEEG = parseEEG;
function parseTelemetry(value) {
    const buffer = new Uint8Array(value.buffer);
    const batteryLevel = ble_utils_1.decodeUint16BitData(buffer.slice(75, 77))[0];
    return { batteryLevel };
}
exports.parseTelemetry = parseTelemetry;
function parseAccel(value) {
    const { index, samples } = nexus_utils_1.decodeMisc(value);
    const axes = nexus_utils_1.decodeAccel(samples);
    const timestamp = getTimestampStreams(index, c.INSAI_MOTION_SAMPLING_RATE, 1, 2);
    return axes.map((a, i) => ({ index, channel: i, timestamp, samples: a }));
}
exports.parseAccel = parseAccel;
function parseGyro(value) {
    const { index, samples } = nexus_utils_1.decodeMisc(value);
    const axes = nexus_utils_1.decodeGyro(samples);
    const timestamp = getTimestampStreams(index, c.INSAI_MOTION_SAMPLING_RATE, 1, 3);
    return axes.map((g, i) => ({ index, channel: i, timestamp, samples: g }));
}
exports.parseGyro = parseGyro;
function parsePPG(value) {
    const { index, samples } = nexus_utils_1.decodeMisc(value);
    const channels = nexus_utils_1.decodePPG(samples);
    const timestamp = getTimestampStreams(index, c.INSAI_MOTION_SAMPLING_RATE, 1, 1);
    return channels.map((p, i) => ({ index, channel: i, timestamp, samples: p }));
}
exports.parsePPG = parsePPG;
//# sourceMappingURL=nexus-parsers.js.map